import React from 'react'
import { withRouter } from 'react-router-dom'

// Dashboard: Dashboard style setup with some grouping and visualizations
class Dashboard extends React.Component {
	render() {
		return (
			<div>
                Dashboard
			</div>
		)
	}

}
export default withRouter(Dashboard)



// WEBPACK FOOTER //
// ./src/App/Home/Dashboard/Dashboard.js